import { LoyaltyCurrencyModel } from '@rd/types/loyalty-currency.model';
import { LoyaltyCurrency } from '@rd/types/loyalty-currency.type';

export function loyaltyCurrencySerializer({
  id,
  attributes,
}: LoyaltyCurrencyModel): LoyaltyCurrency {
  return {
    id,
    ...attributes,
  };
}
